import React from 'react';
import PropTypes from 'prop-types';
import { Icon, State } from 'nallian-shared-ui/lib/components';
import { activeStates } from '../helpers/activeStates';

const stateTag = {
  active: (
    <>
      <State success>
        <Icon name="check" title="Active" />
      </State>
      <State success>Active</State>
    </>
  ),
  unlisted: (
    <>
      <State isnew>
        <Icon name="ban" title="Unlisted" />
      </State>
      <State isnew>Unlisted</State>
    </>
  ),
  inactive: (
    <>
      <State error>
        <Icon name="times" title="Inactive" />
      </State>
      <State error>Validated</State>
    </>
  ),
  deleted: (
    <>
      <State>
        <Icon name="trash" title="Deleted" />
      </State>
      <State>Deleted</State>
    </>
  ),
  pending: (
    <>
      <State>
        <Icon name="wait" title="Pending" />
      </State>
      <State>Pending</State>
    </>
  ),
};

const ActiveState = ({ value }) => {
  const selectedState = activeStates.find(x => x.key === value);

  const stateName = selectedState?.name?.toLowerCase();

  return stateTag[stateName] || '';
};

ActiveState.propTypes = {
  value: PropTypes.number.isRequired,
};

export default ActiveState;
